import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { cn } from '@/utils/utils';
import { FILTER_ITEM, FILTER_MENU, FILTER_TRIGGER } from '@/common/Filter';

type SortValue = 'asc' | 'desc' | 'newest' | 'oldest' | 'rank';

interface SortSelectProps {
  value: SortValue;
  onValueChange: (value: SortValue) => void;
  className?: string;
  size?: 'sm' | 'md';
  /** Limit which entries are offered (default: all four). */
  options?: SortValue[];
}

const SORT_LABELS: Record<SortValue, string> = {
  rank: 'Top rated',
  newest: 'Newest',
  oldest: 'Oldest',
  asc: 'A to Z',
  desc: 'Z to A',
};
const DEFAULT_ORDER: SortValue[] = ['newest', 'oldest', 'asc', 'desc'];

// Widths by size; a caller's className replaces them
const WIDTHS = {
  sm: 'w-24 min-w-[6.25rem] max-w-28',
  md: 'w-28 max-w-44',
};
// A pill, as the dashboard's filters are: 28px tall with a 16px inset when small, 36px with 24px otherwise, its caret 12px from the end
const SHAPES = {
  sm: 'rounded-lureo-radius-pill ps-4',
  md: 'h-9 rounded-lureo-radius-pill ps-6 pe-3',
};

export default function SortSelect({ value, onValueChange, className, size = 'md', options }: SortSelectProps) {
  const items = options ?? DEFAULT_ORDER;

  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger
        size="xs"
        className={cn(SHAPES[size], FILTER_TRIGGER, className || WIDTHS[size])}
        onClick={(e) => {
          e.stopPropagation();
        }}
        onMouseDown={(e) => {
          e.stopPropagation();
        }}>
        <SelectValue placeholder="Sort by" className="text-left truncate" />
      </SelectTrigger>
      <SelectContent className={cn("w-full", FILTER_MENU)} sideOffset={4} align="center">
        {items.map((item) => (
          <SelectItem
            key={item}
            value={item}
            className={FILTER_ITEM}
            onMouseDown={(e) => {
              e.stopPropagation();
            }}
            onSelect={(e) => {
              e.stopPropagation();
            }}>
            {SORT_LABELS[item]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
